<script>
import axios from 'axios';
import {
  UNIT_BLOOM, UNIT_MOVE, UNIT_SWORD, UNIT_MIND,
} from '@/scripts/constants';

export default {
  name: 'TabUnits',
  components: {},
  props: {
    currentTab: { type: Number, required: true },
    tabIndex: { type: Number, required: true },
  },
  data: () => ({
    loaded: false,
    user_id: 0,
    user_units: [],
    unitOptions: [
      { value: UNIT_SWORD, text: 'Thrive' },
      { value: UNIT_BLOOM, text: 'Bloom' },
      { value: UNIT_MOVE, text: 'Move' },
      { value: UNIT_MIND, text: 'Mind' },
    ],
  }),
  watch: {
    currentTab(value) {
      if (this.tabIndex === value && this.loaded === false) {
        this.fetchData();
      }
    },
  },
  async beforeMount() {
    this.user_id = this.$route.params.id;
    await this.fetchData();
  },
  methods: {
    fetchData() {
      this.loaded = true;
      return axios.get(`v1/professionals/${this.user_id}/units`)
        .then(({ data }) => {
          this.user_units = data;
        })
        .catch(err => {
          this.$noty.error('Could not fetch units');
          console.error('Could not fetch units', err);
        });
    },
  },
};
</script>

<template>
  <b-tab title="Units">
    <b-card-text>
      <b-row>
        <b-col cols="12">
          <b-card>
            <div class="mt-3">
              <b-form-group>
                <b-form-checkbox
                  v-for="option in unitOptions"
                  :key="option.value"
                  v-model="user_units"
                  :value="option.value"
                  disabled>
                  {{ option.text }}
                </b-form-checkbox>
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-card-text>
  </b-tab>
</template>
